module.exports = __webpack_public_path__ + "static/media/student-james-clarke.03a40055.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/student-james-clarke.jpg
 ** module id = 512
 ** module chunks = 0
 **/